import script from "./timeTable.vue?vue&type=script&setup=true&lang=js"
export * from "./timeTable.vue?vue&type=script&setup=true&lang=js"

import "./timeTable.vue?vue&type=style&index=0&id=6f31816b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f31816b"]])

export default __exports__